import React, { Component } from 'react';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonCircleList from '../../../common-components/common-circle-list';

const list = [
    'разработали и внедрили 4 языковые версии;',
    'создали дизайн, который отражает специфику деятельности компании ГАП «Ресурс» и подчеркивает образ лидера отрасли;',
    'проработали отображение медиафайлов на трех видах устройств: десктоп, планшет, смартфон;',
    'адаптировали архитектуру для различных устройств.',
];

class Results extends Component {
    render() {
        return (
            <div className="gapresource-results">
                <div className="gapresource-results__inner">
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        <CommonTitle>Результат</CommonTitle>
                    </ScrollAnimation>

                    <div className="gapresource-results__wrapper">
                        <div className="gapresource-results__container">
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                offset={100}
                                animateOnce={true}
                                duration={1}
                            >
                                <CommonSmallTitle className="gapresource-results__subtitle">
                                    В процессе работы над новым сайтом www.gapresurs.ru решили
                                    несколько задач:
                                </CommonSmallTitle>
                            </ScrollAnimation>

                            <CommonCircleList
                                className="gapresource-results__list"
                                classNameInner="gapresource-results__list-inner"
                                CommonCircleList={{
                                    list,
                                    colorNumber: '#65B227',
                                }}
                            />
                        </div>
                        <img
                            className="gapresource-results__img"
                            src="/images/pic/gapresource/result.jpg"
                            alt="pill"
                            loading="lazy"
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default Results;
